import React, { useState, useEffect } from "react";
import './App.css';

// Static Navigation Bar
function Navbar() {
  return (
    <nav>
      <div className="logo">
        <img src="/logo.png" alt="Rusco Brothers Logo" />
      </div>
    </nav>
  );
}

// Simple Image Carousel
function ImageCarousel() {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    "/image1.jpg",  // Replace with actual images
    "/image2.jpg",  // Replace with actual images
    "/image3.jpg",  // Replace with actual images
    "/image4.jpg",  // Replace with actual images
    "/image5.jpg",  // Replace with actual images
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="carousel">
      <img src={images[currentImage]} alt="Project" />
    </div>
  );
}

// Footer with Contact Info
function Footer() {
  return (
    <footer>
      <p>Contact Us: 224-333-0050</p>
      <p>Email: mike@ruscobros.com</p>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <Navbar />
      <div id="home">
        
        <ImageCarousel />
      </div>
      <div id="about">
        <h2>Rusco Brothers Home Builders</h2>
        <p>We build homes with quality and care. Here is a little about our story...</p>
      </div>

      <Footer />
    </div>
  );
}

export default App;
